package one.healthium.log_food.ui.find_food.components

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import loco.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER
import one.healthium.ui.compose.components.AppTextFieldDefaults
import org.jetbrains.compose.resources.stringResource
import kotlin.time.Duration
import kotlin.time.Duration.Companion.seconds

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SearchTextField(
    value: String,
    onValueChange: (String) -> Unit,
    enabled: Boolean = true,
    singleLine: Boolean = true,
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    showKeyboardAutomaticallyIfEmpty: Boolean = false,
    showKeyboardDelay: Duration = 0.seconds,
) {
    val focusRequester = remember { FocusRequester() }

    LaunchedEffect(focusRequester, showKeyboardAutomaticallyIfEmpty, value) {
        if (showKeyboardAutomaticallyIfEmpty && value.isEmpty()) {
            delay(showKeyboardDelay.inWholeMilliseconds)
            focusRequester.requestFocus()
        }
    }

    val colors = AppTextFieldDefaults.colorsGray
    val interactionSource = remember { MutableInteractionSource() }

    BasicTextField(
        modifier = Modifier
            .fillMaxWidth()
            .height(39.dp)
            .focusRequester(focusRequester)
            .testTag("search_text_field"),
        value = value,
        onValueChange = onValueChange,
        interactionSource = interactionSource,
        enabled = enabled,
        singleLine = singleLine,
        keyboardOptions = KeyboardOptions(
            keyboardType = KeyboardType.Text,
            imeAction = ImeAction.Search,
            capitalization = KeyboardCapitalization.Sentences,
        ),
        keyboardActions = keyboardActions,
        decorationBox = @Composable { innerTextField ->
            TextFieldDefaults.DecorationBox(
                value = value,
                colors = colors,
                shape = AppTextFieldDefaults.shapeRounded,
                innerTextField = innerTextField,
                singleLine = singleLine,
                enabled = enabled,
                visualTransformation = VisualTransformation.None,
                leadingIcon = {
                    Icon(
                        Icons.Default.Search,
                        tint = colors.focusedPlaceholderColor,
                        contentDescription = null
                    )
                },
                trailingIcon = {
                    if (value.isNotEmpty()) {
                        IconButton(
                            onClick = {
                                onValueChange("")
                            }
                        ) {
                            Icon(
                                Icons.Default.Close,
                                tint = colors.focusedPlaceholderColor,
                                contentDescription = null
                            )
                        }
                    }
                },
                placeholder = {
                    Text(stringResource(loco.Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER))
                },
                interactionSource = interactionSource,
                contentPadding = TextFieldDefaults.contentPaddingWithoutLabel(
                    top = 0.dp, bottom = 0.dp
                )
            )
        }
    )
}